import { buildUrl, get, post } from '../components/rest/axios-request'
import { changePasswordEndpoint, getBrandEndpoint, getCaptchaKeyEndpoint, requestPasswordResetEndpoint } from '../config/paths'
import { BACKEND_LOGIN_URL } from '../utils/constants'

export const getCaptchaKeyService = (callback, errorCallback) => {
  const url = BACKEND_LOGIN_URL + getCaptchaKeyEndpoint
  get(url, {}, true, callback, errorCallback)
}

export const getBrandConfiguration = (callback, errorCallback) => {
  const url = BACKEND_LOGIN_URL + getBrandEndpoint
  get(url, {}, true, callback, errorCallback)
}

export const requestPasswordResetService = (marcaComercial, body, callback, errorCallback) => {
  const url = BACKEND_LOGIN_URL + buildUrl(requestPasswordResetEndpoint, { marcaComercial })
  post(url, body, {}, true, callback, errorCallback)
}

export const changePasswordService = (marcaComercial, body, headers, callback, errorCallback) => {
  const url = BACKEND_LOGIN_URL + buildUrl(changePasswordEndpoint, { marcaComercial })
  post(url, body, {}, true, callback, errorCallback, headers, false, errorCallback)
}